"use client";

import { WindowProvider } from "../DraggableWindow/context/WindowContext";
import { DesktopContent } from "./desktop-content";

export const Desktop = () => {
    return (
        <WindowProvider>
            <DesktopContent />
        </WindowProvider>
    );
};
